import { ScreenId } from "@vahak/core/dist/constants/admin/screenId";
import { generateSelectOption } from "../../../methods/uiUtil";

export enum VasType {
    CARGO = 1,
    GPS,
    VEHICLE_INSURANCE,
    BUSINESS_LOAN
}

export enum TicketType {
    EWAY_VERIFICATION = 5,
    CALL_ME_BACK = 10,
    HELP = 11,
    VAS_LEADS_CARGO = 12,
    VAS_LEADS_GPS = 13,
    ACCOUNT_DELETION = 14,
    ASSURED_CALLBACK = 15,
    VAS_LEADS_VEHICLE_INSURANCE = 16,
    VAS_LEADS_BUSINESS_LOAN = 17,
    MEMBERSHIP_CALL_ME_BACK = 18,
    IN_TRANSIT_CALLBACK = 19,
    COMPANY_REGISTRATION = 24,
    ADS_LEADS = 26,
    LOAD_POST_SUPPORT = 30,
    AADHAAR_VERIFICATION = 100,
    BUSINESS_VERIFICATION = 200,
    PAN_VERIFICATION = 300,
    RC_VERIFICATION_BLOCKED = 400,
    RC_VERIFICATION_FAILED = 401,
    REFUND_REQUEST = 500,
    BID_CANCELLATION = 510,
    RC_VERIFICATION_FITNESS = 604,
    RC_VERIFICATION_TDS = 605,
    TSO_LEAD_FORM = 700,
    LORRY_BODY_VERIFICATION = 800,
    COMPANY_DL_VERIFICATION = 900
}

export const TicketTypeToNameMap: Partial<Record<TicketType, string>> = {
    [TicketType.RC_VERIFICATION_BLOCKED]: "Lorry Document",
    [TicketType.RC_VERIFICATION_FAILED]: "Lorry Document",
    [TicketType.RC_VERIFICATION_TDS]: "Lorry TDS Document",
    [TicketType.RC_VERIFICATION_FITNESS]: "Lorry Fitness Document",
    [TicketType.LORRY_BODY_VERIFICATION]: "Lorry Body Verification"
};

export enum TicketSystemTypes {
    EWAY_VERIFICATION = "eway",
    RC_VERIFICATION = "rc",
    AADHAAR_VERIFICATION = "aadhaar",
    PAN_VERIFICATION = "pan",
    BUSINESS_VERIFICATION = "business",
    REFUND_REQUEST = "refund-request",
    CALL_ME_BACK = "call-me-back",
    HELP = "help",
    ACCOUNT_DELETION = "account-deletion",
    ASSURED_CALLBACK = "assured-callback",
    VAS_LEADS = "vas-leads",
    BID_CANCELLATION = "bid-cancellation",
    COMPANY_REGISTRATION_LEADS = "company-registration-leads",
    ADS_LEADS = "ads-leads",
    MEMBERSHIP_CALL_ME_BACK = "membership-call-me-back",
    IN_TRANSIT_CALLBACK = "intransit-call-me-back",
    COMPANY_DL_VERIFICATION = "company-dl-verification",
    TSO_ADMIN_LEAD = "tso-admin-leads",
    LOAD_POST_SUPPORT = "load-post-support"
}

export const TicketTypeToSystemTypeMap: Record<TicketType, TicketSystemTypes> = {
    [TicketType.EWAY_VERIFICATION]: TicketSystemTypes.EWAY_VERIFICATION,
    [TicketType.CALL_ME_BACK]: TicketSystemTypes.CALL_ME_BACK,
    [TicketType.HELP]: TicketSystemTypes.HELP,
    [TicketType.VAS_LEADS_CARGO]: TicketSystemTypes.VAS_LEADS,
    [TicketType.VAS_LEADS_GPS]: TicketSystemTypes.VAS_LEADS,
    [TicketType.VAS_LEADS_VEHICLE_INSURANCE]: TicketSystemTypes.VAS_LEADS,
    [TicketType.VAS_LEADS_BUSINESS_LOAN]: TicketSystemTypes.VAS_LEADS,
    [TicketType.ACCOUNT_DELETION]: TicketSystemTypes.ACCOUNT_DELETION,
    [TicketType.ASSURED_CALLBACK]: TicketSystemTypes.ASSURED_CALLBACK,
    [TicketType.MEMBERSHIP_CALL_ME_BACK]: TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK,
    [TicketType.IN_TRANSIT_CALLBACK]: TicketSystemTypes.IN_TRANSIT_CALLBACK,
    [TicketType.COMPANY_REGISTRATION]: TicketSystemTypes.COMPANY_REGISTRATION_LEADS,
    [TicketType.ADS_LEADS]: TicketSystemTypes.ADS_LEADS,
    [TicketType.AADHAAR_VERIFICATION]: TicketSystemTypes.AADHAAR_VERIFICATION,
    [TicketType.BUSINESS_VERIFICATION]: TicketSystemTypes.BUSINESS_VERIFICATION,
    [TicketType.PAN_VERIFICATION]: TicketSystemTypes.PAN_VERIFICATION,
    [TicketType.RC_VERIFICATION_BLOCKED]: TicketSystemTypes.RC_VERIFICATION,
    [TicketType.RC_VERIFICATION_FAILED]: TicketSystemTypes.RC_VERIFICATION,
    [TicketType.RC_VERIFICATION_FITNESS]: TicketSystemTypes.RC_VERIFICATION,
    [TicketType.RC_VERIFICATION_TDS]: TicketSystemTypes.RC_VERIFICATION,
    [TicketType.LORRY_BODY_VERIFICATION]: TicketSystemTypes.RC_VERIFICATION,
    [TicketType.REFUND_REQUEST]: TicketSystemTypes.REFUND_REQUEST,
    [TicketType.BID_CANCELLATION]: TicketSystemTypes.BID_CANCELLATION,
    [TicketType.TSO_LEAD_FORM]: TicketSystemTypes.VAS_LEADS,
    [TicketType.COMPANY_DL_VERIFICATION]: TicketSystemTypes.COMPANY_DL_VERIFICATION,
    [TicketType.LOAD_POST_SUPPORT]: TicketSystemTypes.LOAD_POST_SUPPORT
};

export const TicketTypeMap = {
    [TicketSystemTypes.EWAY_VERIFICATION]: TicketType.EWAY_VERIFICATION,
    [TicketSystemTypes.CALL_ME_BACK]: TicketType.CALL_ME_BACK,
    [TicketSystemTypes.AADHAAR_VERIFICATION]: TicketType.AADHAAR_VERIFICATION,
    [TicketSystemTypes.BUSINESS_VERIFICATION]: TicketType.BUSINESS_VERIFICATION,
    [TicketSystemTypes.PAN_VERIFICATION]: TicketType.PAN_VERIFICATION,
    [TicketSystemTypes.RC_VERIFICATION]: undefined,
    [TicketSystemTypes.REFUND_REQUEST]: TicketType.REFUND_REQUEST,
    [TicketSystemTypes.VAS_LEADS]: undefined,
    [TicketSystemTypes.BID_CANCELLATION]: TicketType.BID_CANCELLATION,
    [TicketSystemTypes.HELP]: TicketType.HELP,
    [TicketSystemTypes.ACCOUNT_DELETION]: TicketType.ACCOUNT_DELETION,
    [TicketSystemTypes.ASSURED_CALLBACK]: TicketType.ASSURED_CALLBACK,
    [TicketSystemTypes.COMPANY_REGISTRATION_LEADS]: TicketType.COMPANY_REGISTRATION,
    [TicketSystemTypes.ADS_LEADS]: TicketType.ADS_LEADS,
    [TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK]: TicketType.MEMBERSHIP_CALL_ME_BACK,
    [TicketSystemTypes.IN_TRANSIT_CALLBACK]: TicketType.IN_TRANSIT_CALLBACK,
    [TicketSystemTypes.COMPANY_DL_VERIFICATION]: TicketType.COMPANY_DL_VERIFICATION,
    [TicketSystemTypes.TSO_ADMIN_LEAD]: TicketType.TSO_LEAD_FORM,
    [TicketSystemTypes.LOAD_POST_SUPPORT]: TicketType.LOAD_POST_SUPPORT
};

export enum TicketSystemDocActionType {
    REJECT = "reject",
    ACCEPT = "accept"
}

export const TicketTitle = {
    [TicketSystemTypes.AADHAAR_VERIFICATION]: "Aadhaar Verification",
    [TicketSystemTypes.RC_VERIFICATION]: "RC Verification",
    [TicketSystemTypes.PAN_VERIFICATION]: "PAN Verification",
    [TicketSystemTypes.BUSINESS_VERIFICATION]: "Business Document Verification",
    [TicketSystemTypes.EWAY_VERIFICATION]: "E-way Bill Verification",
    [TicketSystemTypes.REFUND_REQUEST]: "Refund Request",
    [TicketSystemTypes.CALL_ME_BACK]: "Call me back",
    [TicketSystemTypes.VAS_LEADS]: "VAS Leads",
    [TicketSystemTypes.BID_CANCELLATION]: "Cancellation requests",
    [TicketSystemTypes.HELP]: "Help tickets",
    [TicketSystemTypes.ACCOUNT_DELETION]: "Account deletion",
    [TicketSystemTypes.ASSURED_CALLBACK]: "Assured load call tickets",
    [TicketSystemTypes.COMPANY_REGISTRATION_LEADS]: "Company registration leads",
    [TicketSystemTypes.ADS_LEADS]: "Advertisement leads",
    [TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK]: "Membership support",
    [TicketSystemTypes.IN_TRANSIT_CALLBACK]: "In-Transit CallBack",
    [TicketSystemTypes.COMPANY_DL_VERIFICATION]: "Company DL Verification",
    [TicketSystemTypes.TSO_ADMIN_LEAD]: "TSO Leads",
    [TicketSystemTypes.LOAD_POST_SUPPORT]: "Load post support"
};
export const ExtendedTicketTitle: Partial<Record<TicketType, string>> = {
    [TicketType.RC_VERIFICATION_BLOCKED]: "RC Verification",
    [TicketType.RC_VERIFICATION_FAILED]: "RC Verification",
    [TicketType.RC_VERIFICATION_FITNESS]: "Lorry Fitness Verification",
    [TicketType.RC_VERIFICATION_TDS]: "TDS Verification",
    [TicketType.LORRY_BODY_VERIFICATION]: "Lorry Body Verification"
};

export const TicketSystemRejectionComments = {
    [TicketSystemTypes.AADHAAR_VERIFICATION]: [
        "Image not clear",
        "Image not in proper portion",
        "Image on aadhaar not matching with selfie",
        "Already linked to another account",
        "Selfie image missing"
    ],
    [TicketSystemTypes.PAN_VERIFICATION]: [
        "Name on aadhaar not matching with PAN",
        "Incorrect PAN number",
        "PAN missing",
        "Image not clear"
    ],
    [TicketSystemTypes.BUSINESS_VERIFICATION]: [
        "Document not matching",
        "Already linked to another account",
        "Improper image format",
        "Document Expired"
    ],
    [TicketSystemTypes.RC_VERIFICATION]: [
        "Image not clear",
        "RC number does not match",
        "Upload fitness certificate",
        "RC Missing"
    ],
    [TicketSystemTypes.EWAY_VERIFICATION]: [
        "Invalid E way number",
        "Image not clear",
        "Not an E-way bill",
        "Repeat E-way bill",
        "E-way bill expired",
        "E-way bill date doesn't match",
        "E-way bill GST Doesn't match",
        "Not completed payment",
        "Vehicle number not matching"
    ],
    [TicketSystemTypes.REFUND_REQUEST]: [],
    [TicketSystemTypes.CALL_ME_BACK]: [],
    [TicketSystemTypes.VAS_LEADS]: [],
    [TicketSystemTypes.BID_CANCELLATION]: [],
    [TicketSystemTypes.HELP]: [],
    [TicketSystemTypes.ACCOUNT_DELETION]: [],
    [TicketSystemTypes.ASSURED_CALLBACK]: [],
    [TicketSystemTypes.COMPANY_REGISTRATION_LEADS]: [],
    [TicketSystemTypes.ADS_LEADS]: [],
    [TicketSystemTypes.MEMBERSHIP_CALL_ME_BACK]: [],
    [TicketSystemTypes.IN_TRANSIT_CALLBACK]: [],
    [TicketSystemTypes.COMPANY_DL_VERIFICATION]: ["Image not clear", "Name not as per Aadhaar", "Invalid image"],
    [TicketSystemTypes.TSO_ADMIN_LEAD]: [],
    [TicketSystemTypes.LOAD_POST_SUPPORT]: []
};

export const RejectionCommentsByTicketType: Partial<Record<TicketType, string[]>> = {
    [TicketType.RC_VERIFICATION_BLOCKED]: TicketSystemRejectionComments[TicketSystemTypes["RC_VERIFICATION"]],
    [TicketType.RC_VERIFICATION_FAILED]: TicketSystemRejectionComments[TicketSystemTypes["RC_VERIFICATION"]],
    [TicketType.RC_VERIFICATION_TDS]: [
        "Image not clear",
        "RC number does not match",
        "Upload Tax Deduction Source document"
    ],
    [TicketType.RC_VERIFICATION_FITNESS]: [
        "Image not clear",
        "RC number does not match",
        "Upload fitness certificate",
        "Fitness certificate is expired "
    ],
    [TicketType.LORRY_BODY_VERIFICATION]: [
        "Image not clear",
        "Unable to see vehicle number",
        "Vehicle too far",
        "Vehicle too close"
    ]
};

export const FOSRejectionComment = ["Document not valid", "User not available", "Fraud user"];

export const AcceptAadhaarFormInputLabel = {
    aadhaarNumber: "Enter last 4-digit of Aadhaar number",
    aadhaarName: "Enter Name on Aadhaar",
    state: "Enter State"
};

export const AcceptCompanyDlFormInputLabel = {
    dlNumber: "Enter DL number"
};

export const AcceptEwayFormInputLabel = {
    ewayNumber: "E-way number"
};

export const AcceptGstFormInputLabel = {
    gstType: "Enter document type",
    legalName: "Enter legal name",
    gstNumber: "Enter document number"
};

export const TicketSystemModalTitle = {
    rejection: "Rejection comments",
    acceptAadhaar: "Accept Aadhaar document",
    acceptBusiness: "Accept Business document",
    addComments: "Your Comments",
    acceptPAN: "Accept PAN",
    acceptEWay: "Accept E-Way",
    rcVerification: "Accept RC"
};

export const TicketActionSuccessText: {
    [key in TicketSystemTypes]?: {
        [key in TicketSystemDocActionType]?: string;
    };
} = {
    [TicketSystemTypes.AADHAAR_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "Aadhaar Document Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "Aadhaar Document Accepted Successfully"
    },
    [TicketSystemTypes.PAN_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "PAN Document Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "PAN Document Accepted Successfully"
    },
    [TicketSystemTypes.BUSINESS_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "Business Document Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "Business Document Accepted Successfully"
    },
    [TicketSystemTypes.RC_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "Document Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "Document Accepted Successfully"
    },
    [TicketSystemTypes.EWAY_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "E-way Bill Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "E-way Bill Accepted Successfully"
    },
    [TicketSystemTypes.COMPANY_DL_VERIFICATION]: {
        [TicketSystemDocActionType.REJECT]: "Company DL Document Rejected Successfully",
        [TicketSystemDocActionType.ACCEPT]: "Company DL Document Accepted Successfully"
    }
};

export enum TicketStatusMap {
    Unverified = 0,
    Verified = 1,
    // PhysicalVerification = 3,
    Resolving = 4,
    // FOSVerification = 5,
    Rejected = 999
}

export const KycStatusMap = {
    [TicketStatusMap.Unverified]: "Unverified",
    [TicketStatusMap.Verified]: "Verified",
    [TicketStatusMap.Rejected]: "Rejected",
    [TicketStatusMap.Resolving]: ""
};

export const CallMeBackStatusMap = {
    [TicketStatusMap.Unverified]: "New",
    [TicketStatusMap.Verified]: "Closed",
    [TicketStatusMap.Rejected]: "", // Not Using
    [TicketStatusMap.Resolving]: ""
};

export const RefundRequestStatusMap = {
    [TicketStatusMap.Unverified]: "Pending",
    [TicketStatusMap.Verified]: "Approved",
    [TicketStatusMap.Rejected]: "Rejected",
    [TicketStatusMap.Resolving]: ""
};

export enum TicketStatusText {
    ALL = "All",
    PENDING = "Pending",
    REJECTED = "Rejected",
    ACCEPTED = "Accepted",
    Resolving = "Resolving"
}

export enum TicketDocumentName {
    LR_DOC = "lrDoc",
    EWAY_DOC = "ewayDoc",
    GOODS_DOC = "goodsDoc",
    POD_DOC = "podDoc",
    RC_DOC = "rcDoc",
    LORRY_FITNESS_DOC = "lorryFitnessDoc",
    TDS_DOC = "tdsDoc",
    VEHICLE_INSURANCE_DOC = "vehicleInsuranceDoc",
    VEHICLE_OWNER_AADHAAR_DOC = "vehicleOwnerAadhaarDoc",
    DRIVER_LICENSE_DOC = "driverLicenseDoc",
    DRIVER_AADHAAR_DOC = "driverAadhaarDoc",
    SHOP_IMAGE_DOC = "shopImageDoc",

    // TYPESCRIPT
    AADHAAR_FRONT = "frontDoc",
    AADHAAR_BACK = "backDoc",
    AADHAAR_SELFIE = "selfieDoc",
    GST_CERTIFICATE = "gstCertificate",
    MSME_CERTIFICATE = "msmeCertificate",
    GUMASTA_LICENSE = "gumastaLicense",
    TRADE_LICENSE = "tradeLicense",
    RC_VALIDATION = "rcValidation",
    SUPPORTING_DOC = "supportDoc",
    LORRY_BODY_FRONT_VIEW = "frontDoc",
    LORRY_BODY_BACK_VIEW = "backDoc",
    LORRY_BODY_SIDE_VIEW = "sideDoc",
    COMPANY_DRIVER_LICENSE_FRONT = "companyDriverLicenseFrontDoc",
    COMPANY_DRIVER_LICENSE_BACK = "companyDriverLicenseBackDoc"
}

export enum TicketDocument {
    LORRY_RECEIPT = 1,
    POD = 2,
    SUPPORTING_DOC = 3,
    EWAY_BILL = 5,
    GOODS_INVOICE = 6,
    SHOP_IMAGE = 7,
    AADHAAR_FRONT = 100,
    AADHAAR_BACK = 101,
    AADHAAR_SELFIE = 102,
    GST_CERTIFICATE = 200,
    MSME_CERTIFICATE = 201,
    GUMASTA_LICENSE = 202,
    TRADE_LICENSE = 203,
    // PAN = 300,
    RC_VALIDATION = 400,
    RC_DOCUMENT = 401,
    DRIVER_LICENSE = 600,
    VEHICLE_INSURANCE = 601,
    DRIVER_AADHAAR = 602,
    VEHICLE_OWNER_AADHAAR = 603,
    LORRY_FITNESS = 604,
    TDS = 605,
    LORRY_BODY_FRONT_VIEW = 800,
    LORRY_BODY_BACK_VIEW = 801,
    LORRY_BODY_SIDE_VIEW = 802,
    COMPANY_DRIVER_LICENSE_FRONT = 900,
    COMPANY_DRIVER_LICENSE_BACK = 901
}
export const TICKET_TYPE_NAME_MAP = {
    [TicketDocument.LORRY_RECEIPT]: TicketDocumentName.LR_DOC,
    [TicketDocument.POD]: TicketDocumentName.POD_DOC,
    [TicketDocument.EWAY_BILL]: TicketDocumentName.EWAY_DOC,
    [TicketDocument.GOODS_INVOICE]: TicketDocumentName.GOODS_DOC,
    [TicketDocument.SHOP_IMAGE]: TicketDocumentName.SHOP_IMAGE_DOC,
    [TicketDocument.RC_DOCUMENT]: TicketDocumentName.RC_DOC,
    [TicketDocument.LORRY_FITNESS]: TicketDocumentName.LORRY_FITNESS_DOC,
    [TicketDocument.TDS]: TicketDocumentName.TDS_DOC,
    [TicketDocument.VEHICLE_INSURANCE]: TicketDocumentName.VEHICLE_INSURANCE_DOC,
    [TicketDocument.VEHICLE_OWNER_AADHAAR]: TicketDocumentName.VEHICLE_OWNER_AADHAAR_DOC,
    [TicketDocument.DRIVER_LICENSE]: TicketDocumentName.DRIVER_LICENSE_DOC,
    [TicketDocument.DRIVER_AADHAAR]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.RC_VALIDATION]: TicketDocumentName.RC_DOC,

    //TYPESCRIPT - to avoid error
    [TicketDocument.AADHAAR_FRONT]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.AADHAAR_BACK]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.AADHAAR_SELFIE]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.GST_CERTIFICATE]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.MSME_CERTIFICATE]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.GUMASTA_LICENSE]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.TRADE_LICENSE]: TicketDocumentName.DRIVER_AADHAAR_DOC,
    [TicketDocument.SUPPORTING_DOC]: TicketDocumentName.SUPPORTING_DOC,

    // Lorry Body Verification
    [TicketDocument.LORRY_BODY_FRONT_VIEW]: TicketDocumentName.LORRY_BODY_FRONT_VIEW,
    [TicketDocument.LORRY_BODY_BACK_VIEW]: TicketDocumentName.LORRY_BODY_BACK_VIEW,
    [TicketDocument.LORRY_BODY_SIDE_VIEW]: TicketDocumentName.LORRY_BODY_SIDE_VIEW,
    [TicketDocument.COMPANY_DRIVER_LICENSE_FRONT]: TicketDocumentName.COMPANY_DRIVER_LICENSE_FRONT,
    [TicketDocument.COMPANY_DRIVER_LICENSE_BACK]: TicketDocumentName.COMPANY_DRIVER_LICENSE_BACK
};

export const TicketDocumentText: { [key in TicketDocument]: string } = {
    [TicketDocument.SUPPORTING_DOC]: "Supporting Documents",
    [TicketDocument.EWAY_BILL]: "Eway Bill",
    [TicketDocument.SHOP_IMAGE]: "Shop Image",

    [TicketDocument.AADHAAR_FRONT]: "Front image of aadhaar",
    [TicketDocument.AADHAAR_BACK]: "Back image of aadhaar",
    [TicketDocument.AADHAAR_SELFIE]: "Selfie",

    [TicketDocument.GST_CERTIFICATE]: "GST Certificate",
    [TicketDocument.MSME_CERTIFICATE]: "MSME Certificate",
    [TicketDocument.GUMASTA_LICENSE]: "Gumasta License",
    [TicketDocument.TRADE_LICENSE]: "Trade License",
    [TicketDocument.RC_VALIDATION]: "RC Validation",
    [TicketDocument.POD]: "POD",
    [TicketDocument.RC_DOCUMENT]: "RC Document",
    [TicketDocument.LORRY_FITNESS]: "Lorry Fitness",
    [TicketDocument.TDS]: "TDS",
    [TicketDocument.DRIVER_LICENSE]: "Driver License",
    [TicketDocument.VEHICLE_INSURANCE]: "Vehicle Insurance",
    [TicketDocument.DRIVER_AADHAAR]: "Driver Aadhaar",
    [TicketDocument.VEHICLE_OWNER_AADHAAR]: "Vehicle Owner Aadhaar",
    [TicketDocument.LORRY_RECEIPT]: "Lorry Receipt",
    [TicketDocument.GOODS_INVOICE]: "Goods Invoice",

    [TicketDocument.LORRY_BODY_FRONT_VIEW]: "Front View",
    [TicketDocument.LORRY_BODY_BACK_VIEW]: "Back View",
    [TicketDocument.LORRY_BODY_SIDE_VIEW]: "Side View",
    [TicketDocument.COMPANY_DRIVER_LICENSE_FRONT]: "Front View",
    [TicketDocument.COMPANY_DRIVER_LICENSE_BACK]: "Back View"
};

export enum TicketStatusFilterValue {
    ALL = "",
    PENDING = 0,
    ACCEPTED = 1,
    PhysicalVerification = 3,
    FosVerified = 5,
    REJECTED = 999
}

export enum SubscriptionPlan {
    SHIPPER = 1,
    TRUCKER = 2,
    TRANSPORTER = 3
}

export const SubscriptionPlanText = {
    [SubscriptionPlan.SHIPPER]: "Shipper",
    [SubscriptionPlan.TRUCKER]: "Trucker",
    [SubscriptionPlan.TRANSPORTER]: "Transporter"
};

export enum TicketCallMeBackStatus {
    ALL = "All",
    NEW = "New",
    CLOSE = "Closed"
}

export const TableColumnName = {
    dateTime: {
        name: "dateTime",
        displayName: "Date & Time"
    },
    userProfile: {
        name: "userProfile",
        displayName: "User Profile"
    },
    status: {
        name: "status",
        displayName: "Status"
    },
    billNumber: {
        name: "billNumber",
        displayName: "E-way Bill Number"
    },
    lorryNumber: {
        name: "lorryNumber",
        displayName: "Lorry Number"
    },
    documentStatus: {
        name: "documentStatus",
        displayName: "Documents Status"
    },
    viewDocument: {
        name: "viewDocument",
        displayName: "View Documents"
    },
    actionNdRemarks: {
        name: "actionNdRemarks",
        displayName: "Action & Remarks"
    },
    reason: {
        name: "reason",
        displayName: "Reason"
    },
    refundRequestDateAndTime: {
        name: "dateTime",
        displayName: "Date & Time"
    },
    refundRequestedBy: {
        name: "refundRequestedBy",
        displayName: "Requested By"
    },
    refundRequestedFrom: {
        name: "refundRequestedFrom",
        displayName: "Requested From"
    },
    refundDetails: {
        name: "refundDetails",
        displayName: "Details"
    },
    refundStatusAndAction: {
        name: "refundStatusAndAction",
        displayName: "Updates"
    },
    vasLeadDetails: {
        name: "vasLeadDetails",
        displayName: "Details"
    },
    actionSlot: {
        name: "actionSlot",
        displayName: "action"
    },
    updatedBy: {
        name: "updatedBy",
        displayName: "Updated By"
    },
    source: {
        displayName: "Source",
        name: "source"
    },
    remarks: {
        displayName: "Remarks",
        name: "remarks"
    },
    misc: {
        displayName: "Misc",
        name: "misc"
    }
};

export enum LoadTicketType {
    VERIFICATION = 20,
    FULFILLMENT = 21,
    // VERIFIED_2 = 22,
    PP_PLACEMENT = 27,
    PP_LOADING = 28,
    PP_UNLOADING = 29
}

export const LoadTicketTypeList = [
    LoadTicketType.VERIFICATION,
    LoadTicketType.FULFILLMENT,
    LoadTicketType.PP_PLACEMENT,
    LoadTicketType.PP_LOADING,
    LoadTicketType.PP_UNLOADING
];

export const LoadTicketTypeToAgentTypeNameMap = {
    [LoadTicketType.VERIFICATION]: "Verification",
    [LoadTicketType.FULFILLMENT]: "Fulfillment",
    [LoadTicketType.PP_PLACEMENT]: "PP Placement",
    [LoadTicketType.PP_LOADING]: "PP Loading",
    [LoadTicketType.PP_UNLOADING]: "PP Unloading"
};
export const LoadTicketTypeToNameMap = {
    [LoadTicketType.VERIFICATION]: ScreenId.loadVerification,
    [LoadTicketType.FULFILLMENT]: ScreenId.loadFulfillment,
    [LoadTicketType.PP_PLACEMENT]: ScreenId.ppPlacement
};
export const LoadTicketNameToTypeMap = {
    [ScreenId.loadVerification]: LoadTicketType.VERIFICATION,
    [ScreenId.loadVerificationAdmin]: LoadTicketType.VERIFICATION,
    [ScreenId.loadFulfillment]: LoadTicketType.FULFILLMENT,
    [ScreenId.assuredLoads]: LoadTicketType.FULFILLMENT,

    // Post Placement
    [ScreenId.ppAllLoad]: undefined,
    [ScreenId.ppPlacement]: LoadTicketType.PP_PLACEMENT,
    [ScreenId.ppLoading]: LoadTicketType.PP_LOADING,
    [ScreenId.ppUnloading]: LoadTicketType.PP_UNLOADING,
    [ScreenId.ppCompleted]: undefined,
    [ScreenId.ppCancelled]: undefined
};

export const DispositionSourceScreen = {
    LOAD_LIST: "load-list",
    LORRY_LIST: "lorry-list",
    TSO_LOAD: "tso-load",
    TSO_LORRY: "tso-lorry"
};

const CancelLoadBidDInstantOptionNameWithValue = {
    "Vahak coin": "false",
    "Same source account": "true"
};

export const CancelLoadBidDInstantOptionList = Object.entries(CancelLoadBidDInstantOptionNameWithValue).map(
    ([key, value]) =>
        generateSelectOption(
            key,
            value as typeof CancelLoadBidDInstantOptionNameWithValue[keyof typeof CancelLoadBidDInstantOptionNameWithValue]
        )
);
